import { ITerritoryRepository } from "@/repository/territory/TerritoryRepository.types";
import Api from "@/repository/api";
import Territory from "@/entity/territory/territory";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import qs from "qs";
import {ICity, CityItemResponseType, CityResponseType, City, DataEntity } from "@/entity/territory/territory.types";
import {getResponse, getResponseQs} from "@/repository/Helpers/repositoryLib";

export class TerritoryRepository implements ITerritoryRepository {
    async fetchAll(data?: FormData): Promise<City> {
        const response = await getResponse(`/city/get`, data)
        return response.data  as City
    }

    async fetchData(data: PaginationRequestType): Promise<DataEntity> {
        const response = await getResponseQs(`/city/get`, data);
        return  response.data as DataEntity;
    }

    async fetchCity(data?: PaginationRequestType): Promise<CityResponseType> {
        const response = await Api.get('/city/get', { params: data, paramsSerializer: function paramsSerializer(params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const respData = response.data as CityResponseType;
        return new Territory(respData).city;
    }

    /*async fetchRegion(data?: FormData): Promise<IRegion[]> {
        const response = await Api.get('/region/get', { params: data, paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            }});
        const respData = response.data as RegionResponseType[];
        return new Territory(respData).region;
    }*/
}
